import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFireDatabase } from "@angular/fire/database";
import { AngularFireFunctions } from "@angular/fire/functions";
import { auth } from "firebase/app";

import { LoadingService } from "./loading.service";
import { Platform } from "@ionic/angular";

import { GooglePlus } from "@ionic-native/google-plus/ngx";

import { environment } from "src/environments/environment.prod";
import { Router } from "@angular/router";
import { DataService } from "./data.service";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  constructor(
    private afFunctions: AngularFireFunctions,
    private afAuth: AngularFireAuth,
    private afdb: AngularFireDatabase,
    private loadingProvider: LoadingService,
    private platform: Platform,
    private gplus: GooglePlus,
    private router: Router,
    private dataProvider: DataService
  ) {}

  login(email, password) {
    this.loadingProvider.show();
    this.afAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then((success) => {
        this.loadingProvider.hide();
      })
      .catch((err) => {
        this.loadingProvider.showToast("Error Logging in");
      });
  }

  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
      c
    ) {
      const r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  register(
    name,
    username,
    email,
    password,
    img,
    company,
    //requestedGroup,
    club
  ) {
    this.loadingProvider.show();

    this.afAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then((res) => {
        let user: any = this.afAuth.auth.currentUser;

        this.createNewUser(
          user.uid,
          name,
          username,
          user.email,
          "I am available",
          "Firebase",
          img,
          company,
          //requestedGroup,
          club
        );
      })
      .catch((err) => {
        console.log(err);
        this.loadingProvider.hide();
        this.loadingProvider.showToast(err.message);
      });
  }

  createNewUser(
    userId,
    name,
    username,
    email,
    description = "I'm available",
    provider,
    img = "./assets/images/default-dp.png",
    company,
    //requestedGroup,
    club
  ) {
    let dateCreated = new Date();
    let role = "client";

    this.afdb
      .object("/accounts/" + userId)
      .update({
        dateCreated,
        username,
        name,
        userId,
        email,
        description,
        provider,
        img,
        role,
        company,
        //requestedGroup,
        club,
        enabled: true,
        friends: ["u6bU20TCQISLyCk9z80mIUpGiBy1"],
      })
      .then(() => {
        //this.addUserToMission(userId);
        this.router.navigateByUrl("/login");
      });
  }

  addUserToMission(userId) {
    const missionId = this.dataProvider.getFoundationMissionId();

    this.dataProvider
      .getMission(this.dataProvider.getFoundationMissionId())
      .snapshotChanges()
      .subscribe((missionRes: any) => {
        const mission = {
          $key: missionRes.key,
          ...missionRes.payload.val(),
        };
        this.afdb.list("/accounts/" + userId + "/missions").set(missionId, {
          messagesRead: 0,
        });

        let members = mission.members;

        if (members == undefined) {
          members = [];
        }

        if (members.indexOf(userId) == -1) {
          members.push(userId);

          // Update group data on the database.
          this.dataProvider
            .getMission(missionId)
            .update({
              members: members,
            })
            .then(() => {
              // Back.
              this.loadingProvider.hide();
            });
        }
      });
  }

  adminRegister(name, username, email, password, img, company) {
    this.loadingProvider.show();

    const data = {
      displayName: username,
      name,
      email,
      company,
      password,
    };

    this.afdb
      .object("/newusers/" + this.uuidv4())
      .update(data)
      .then(() => {
        this.loadingProvider.hide();
        this.loadingProvider.showToast("New user registered");
        this.router.navigateByUrl("/login");
      })
      .catch((err) => {
        this.loadingProvider.showToast(err);
        this.loadingProvider.hide();
      });
  }

  reset(email) {
    this.afAuth.auth
      .sendPasswordResetEmail(email)
      .then(() => {
        this.loadingProvider.showToast("Please Check your inbox");
      })
      .catch((err) => {
        this.loadingProvider.showToast(err.message);
      });
  }

  logout() {
    this.afAuth.auth.signOut().then(() => this.router.navigateByUrl("/login"));
  }
}
